import ActiveCampaignPage, { Props } from './CampaignPage'
import DisabledCampaignPage from './DisabledCampaignPage'

const CampaignPage = ({ campaign, ...rest }: Props) => {
  // Temporary disabled campaign page for angel-2 only
  if (campaign.slug === 'angel-2') {
    return <DisabledCampaignPage campaign={campaign} />
  }
  return <ActiveCampaignPage campaign={campaign} {...rest} />
}

export default CampaignPage
